import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57da5946"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-images" }

import { PropType } from 'vue'
import GameImage from './GameImage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GameImages',
  props: {
  images: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image, index) => {
      return (_openBlock(), _createBlock(GameImage, {
        key: index,
        image: image
      }, null, 8, ["image"]))
    }), 128))
  ]))
}
}

})